import DataTable from "./DataTable";
import TableToolbar from "./TableToolbar";
import useTableFilters from "../../hooks/useTableFilters";

export default function FilteredDataTable({
  data,
  columns,
  config,
  initialFilters,
  pageSize = 10,
  emptyMessage = "No records match your filters.",
  onRowClick,
  compact = false,
  toolbarClassName = "",
  tableClassName = "",
  selectable = false,
  selectedIds = [],
  onSelectionChange,
  getRowId = (row) => row.id ?? row.case_id,
  bulkBar = null,
  maxVisibleColumns,
  fitContainer = false,
}) {
  const filterState = useTableFilters(data, config, initialFilters);
  const {
    filtered,
    filters,
    setFilter,
    resetFilters,
    removeFilter,
    activeCount,
    activeChips,
    metrics,
    drawerOpen,
    setDrawerOpen,
    fieldOptions,
  } = filterState;

  const handleToggleRow = (rowId) => {
    if (!onSelectionChange) return;
    const next = selectedIds.includes(rowId)
      ? selectedIds.filter((id) => id !== rowId)
      : [...selectedIds, rowId];
    onSelectionChange(next);
  };

  const handleTogglePage = (pageIds, select) => {
    if (!onSelectionChange) return;
    if (select) {
      const merged = new Set([...selectedIds, ...pageIds]);
      onSelectionChange([...merged]);
      return;
    }
    const remove = new Set(pageIds);
    onSelectionChange(selectedIds.filter((id) => !remove.has(id)));
  };

  return (
    <div className={tableClassName}>
      <TableToolbar
        config={config}
        filters={filters}
        setFilter={setFilter}
        resetFilters={resetFilters}
        removeFilter={removeFilter}
        activeCount={activeCount}
        activeChips={activeChips}
        metrics={metrics}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        fieldOptions={fieldOptions}
        totalCount={data.length}
        filteredCount={filtered.length}
        className={`mb-4 ${toolbarClassName}`}
      />
      {typeof bulkBar === "function"
        ? bulkBar({ filtered, filters, selectedIds })
        : bulkBar}
      <DataTable
        columns={columns}
        data={filtered}
        pageSize={pageSize}
        emptyMessage={emptyMessage}
        onRowClick={onRowClick}
        compact={compact}
        selectable={selectable}
        selectedIds={selectedIds}
        getRowId={getRowId}
        onToggleRow={handleToggleRow}
        onTogglePage={handleTogglePage}
        maxVisibleColumns={maxVisibleColumns}
        fitContainer={fitContainer}
      />
    </div>
  );
}

export { useTableFilters };
